import { _post } from "@/utils/request.js";
const preApi = process.env.NODE_ENV !== "production" ? "/api" : process.env.VUE_APP_API;
const URL = {
  eraser: preApi + "/ai/erase_pen/pre",
};

const inpaint = async (data) => _post(URL.eraser, data);

export { inpaint };
